import { useState } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { useEigeneProAnfrage, useProAnfrageStellen } from '../../hooks/useQualyz'
import { fehlerText } from '../../lib/api'
import { formatDatum } from '../../lib/lenses'

/**
 * „Pro anfragen" -- die Anfrage landet im System, nicht im Mailprogramm.
 *
 * Vorher war das ein `mailto:`-Link: Er öffnete das Mailprogramm des
 * Besuchers, und ob dort je eine Mail abging, erfuhr niemand (Kim,
 * 23.09.2026). Jetzt sieht Kim jede Anfrage in seinem Zugang -- und der
 * Kunde sieht, dass sie angekommen ist.
 */
export default function ProAnfrageKnopf({ klasse = 'q-btn q-btn-primary q-btn-sm' }: { klasse?: string }) {
  const { isAuthenticated } = useAuth()
  const eigene = useEigeneProAnfrage()
  const stellen = useProAnfrageStellen()
  const [fehler, setFehler] = useState<string | null>(null)

  if (!isAuthenticated) {
    return (
      <a className={klasse} href="/login">
        Anmelden für Pro
      </a>
    )
  }

  const anfrage = eigene.data?.anfrage
  if (anfrage?.status === 'offen' || stellen.isSuccess) {
    const seit = anfrage?.gestellt_am ? formatDatum(anfrage.gestellt_am.slice(0, 10)) : null
    return (
      <span className="q-anfrage-stand" role="status">
        Anfrage ist eingegangen{seit ? ` (${seit})` : ''}. Wir melden uns.
      </span>
    )
  }

  return (
    <>
      <button
        type="button"
        className={klasse}
        disabled={stellen.isPending}
        onClick={async () => {
          setFehler(null)
          try {
            await stellen.mutateAsync(undefined)
          } catch (f) {
            setFehler(fehlerText(f))
          }
        }}
      >
        {stellen.isPending ? 'Sende …' : 'Pro anfragen'}
      </button>
      {fehler && <span className="q-anfrage-stand is-fehler">{fehler}</span>}
    </>
  )
}
